
import { defineComponent } from 'vue';
import draggable from 'vuedraggable';
import Form from '@/shared/mixins/Form';
import { estateAgencyService } from '@/estate-agency/EstateAgencyService';
import { estateAgentService } from '@/estate-agent/EstateAgentService';
import EstateAgentListItem from '@/estate-agent/components/EstateAgentListItem.vue';
import EstateAgentInsert from '@/estate-agent/EstateAgentInsert.vue';
import EstateAgentEdit from '@/estate-agent/EstateAgentEdit.vue';
import ResizableImage from '@/shared/components/ResizableImage.vue';

export default defineComponent({
  name: 'EstateAgencyProfile',
  mixins: [Form],
  components: {
    ResizableImage,
    EstateAgentListItem,
    EstateAgentInsert,
    EstateAgentEdit,
    draggable,
  },
  data() {
    return {
      showEstateAgentInsertModal: false,
      showEstateAgentEditModal: false,
      isRecordOrderEnabled: false,
      editFrontUserId: 0,
      estateAgency: {},
      estateAgents: [],
    };
  },
  async created() {
    this.isLoading = true;
    try {
      const result = await estateAgencyService.getProfile();
      this.estateAgency = result.data;
      await this.loadAgents();
    } catch (error) {
      console.error(error);
    } finally {
      this.isLoading = false;
    }
  },
  computed: {
    dragOptions() {
      return {
        animation: 500,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost',
      };
    },
  },
  methods: {
    async loadAgents() {
      const resultAgents = await estateAgencyService.getProfileEstateAgents();
      this.estateAgents = resultAgents.data.data;
    },
    onEstateAgentInserted() {
      this.loadAgents();
    },
    onEstateAgentUpdated() {
      this.loadAgents();
    },
    onEstateAgentDeleted() {
      this.loadAgents();
    },
    onEstateAgentEdit(frontUserId: number) {
      this.showEstateAgentEditModal = true;
      this.editFrontUserId = frontUserId;
    },
    enableRecordOrder() {
      this.isRecordOrderEnabled = true;
    },
    async saveRecordOrder() {
      this.startLoading();

      try {
        let result = this.estateAgents.map((agent, index) => {
          return {
            frontUserId: agent.frontUserId,
            recordOrder: index + 1,
          };
        });

        await estateAgentService.updateRecordOrder({
          estateAgents: result,
        });

        this.isRecordOrderEnabled = false;
      } catch (error) {
        this.handleApiError(error);
      } finally {
        this.endLoading();
      }
    },
  },
});
